var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"testimonials section-spacing"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row p-5 text-gray"},[_c('TestimonialCard',{attrs:{"extraClass":"text-font-lg text-white"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }